import React, { memo, useCallback, useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { useHistory } from 'react-router-dom';
import Swiper from 'react-id-swiper';
import 'swiper/css/swiper.css';
import QRCode from 'qrcode.react';
import styles from './AIGCHeader.module.less';

import { CONTEXT } from '../../../../config';
import { logging } from '../../../../actions/log';
import { aigcShowDialog } from '../../../../actions/aigc';
import { addClass, changeClass, getStringCharLength } from '../../../../utils/utils';
import { PCStoreJsBridge } from '../../../../nativeapi';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const selectAIGC = createSelector(
  state => state.aigc,
  aigc => aigc,
);

export default memo(({ AIGCRef }) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const logInfoData = useSelector(selectLogInfo);
  const AIGCObj = useSelector(selectAIGC); //

  const handleClose = useCallback(() => {
    if (AIGCRef?.current) {
      changeClass(AIGCRef?.current, styles.aigc_out, styles.aigc_in);
      // addClass(AIGCRef?.current, styles.aigc_in)
    }
    setTimeout(() => {
      dispatch(
        aigcShowDialog({
          show: false,
        }),
      );
    }, 300);
  }, [AIGCRef]);

  // 移动窗口Mouse
  const handleWindowHtCaption = useCallback(ev => {
    ev.stopPropagation();
    if (ev.target instanceof HTMLAnchorElement || ev.target instanceof HTMLInputElement) {
      return;
    }
    PCStoreJsBridge.startMoveWindow();
  }, []);
  // 移动窗口触屏
  const handleTouchStart = useCallback(ev => {
    ev.stopPropagation();
    if (ev.target instanceof HTMLAnchorElement || ev.target instanceof HTMLInputElement) {
      return;
    }
    if (ev.targetTouches) {
      PCStoreJsBridge.touchStartWindow(ev.targetTouches[0]);
    } else {
      PCStoreJsBridge.touchStartWindow();
    }
  }, []);
  // 移动窗口
  const handleTouchMove = useCallback(ev => {
    if (ev.targetTouches) {
      PCStoreJsBridge.touchMoveWindow(ev.targetTouches[0]);
    } else {
      PCStoreJsBridge.touchMoveWindow();
    }
  }, []);
  // 移动窗口结束
  const handleTouchEnd = useCallback(ev => {
    PCStoreJsBridge.touchEndWindow();
  }, []);

  return (
    <div
      className={styles.aigc_header}
      onMouseDown={handleWindowHtCaption}
      onTouchStart={handleTouchStart}
      onTouchMove={handleTouchMove}
      onTouchEnd={handleTouchEnd}
    >
      <div
        className={`iconfont icon-opt_back aigc_header_back`}
        onClick={() => {
          handleClose();
        }}
      ></div>
      <div className={`aigc_header_title`}>小乐智能</div>
      <div className={`aigc_header_info`}></div>
    </div>
  );
});
